import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ValidationResourceProvider } from './validation.resource';
import { FormHelperComponent } from './form-helper/form-helper.component';

@NgModule({
  declarations: [FormHelperComponent],
  providers: [ValidationResourceProvider],
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  exports: [FormsModule, ReactiveFormsModule, FormHelperComponent],
})
export class RsmFormsModule {}
